const snack = (state) => {
  return state.snackbar
}

const modal = (state) => {
  return state.modal
}

export { snack, modal }
